import React, { Suspense, useState } from 'react';
import { Box, Alert, Typography } from "@mui/material";
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { CircleLoading } from 'components/loaders/Loaders';
import { PusherProvider } from 'hooks/usePusher';
import { useAuth } from 'context/UseContext';
import { ErrorToaster, SuccessToaster } from 'components/toaster/Toaster';
import AuthServices from 'apis/auth/AuthServices';
import VerifyOtp from 'components/verifyOtp/VerifyOtp';

function DashboardLayout() {

  const { user, saveUserDetail } = useAuth();

  const [mobileOpen, setMobileOpen] = useState(false);

  const [openOtpDialog, setOpenOtpDialog] = useState(false);

  const [loading, setLoading] = useState(false);
  const [otpVerificationError, setOtpVerificationError] = useState('');

  // *For Resend Code
  const sendWhatsAppOtp = async () => {
    setOpenOtpDialog(true)
    try {
      const obj = {
        phone_number: user?.whatsapp_number
      }
      const { message } = await AuthServices.sendWhatsAppOtp(obj)
      SuccessToaster(message);
    } catch (error) {
      ErrorToaster(error);
    }
  }

  // *For Verify OTP 
  const verifyOtp = async (otpCode) => {
    setLoading(true)
    try {
      const obj = {
        whatsapp_number: user?.whatsapp_number,
        whatsapp_code: otpCode?.whatsappOtpCode,
      }
      const { message } = await AuthServices.verifyOtp2(obj)
      SuccessToaster("Number verified successfully.");
      const updatedData = { ...user, iswhatsappverified: true }
      saveUserDetail(updatedData)
      setOpenOtpDialog(false)
    } catch (error) {
      setOtpVerificationError(true)
      ErrorToaster(error);
    } finally {
      setLoading(false)
    }
  }

  return (
    <PusherProvider>

      <VerifyOtp
        loading={loading}
        error={otpVerificationError}
        open={openOtpDialog}
        otpNumber={user?.whatsapp_number}
        register={verifyOtp}
      />

      {/* ========== Header ========== */}
      <Header onMenuClick={() => setMobileOpen(true)} />

      <Box sx={{ display: 'flex' }}>

        {/* ========== Sidebar ========== */}
        <Sidebar mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />

        <Box component="main" sx={{ height: 'calc(100vh - 104px)', width: 1, position: 'relative', overflowY: 'auto', py: 2.5, px: 2 }}>
          {(user && !user?.iswhatsappverified) &&
            <Alert severity="error" sx={{ mb: 2 }}>
              You have not verified your whatsapp number. You can resend verification code by{" "}
              <Typography component="span" onClick={() => sendWhatsAppOtp()} sx={{ color: '#518ecb', cursor: 'pointer' }}>
                clicking here
              </Typography>.
            </Alert>
          }
          <Suspense fallback={<CircleLoading />}>
            <Outlet />
          </Suspense>
        </Box>

      </Box>

    </PusherProvider>
  )
}

export default DashboardLayout